-<template>
  <span class="check_ui">
    <input
      value="foo"
      :checked="value === true || value === 1"
      v-on:change="updateInput"
      :id="random"
      type="checkbox"
    />
    <label :for="random">
      <i />
    </label>
  </span>
</template>

<script>
export default {
  name: "Toggle",
  props: ["value", "useInteger"],
  data: function() {
    return {
      random: "toggle-" + Math.ceil(Math.random() * 100000000000000000)
    };
  },
  methods: {
    updateInput: function(event) {
      /*
       *  The toggle can return either a boolean (true or false),
       *  Or, if useInteger is true, it can return 1 or 0
       */

      const checked = event.target.checked;
      let newVal = false;
      // checked
      if (checked) {
        newVal = this.useInteger ? 1 : true;
      }
      // not checked
      else {
        newVal = this.useInteger ? 0 : false;
      }
      this.$emit("input", newVal);
    }
  }
};
</script>

<style></style>
